var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"rank-table"},[_c('dv-scroll-board',{staticClass:"scroll-board",attrs:{"config":_vm.tableData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }